import React, { useEffect, useState } from "react";
import { adminApi } from "../../api/admin";

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);

  useEffect(() => {
    adminApi.getOrders({ skip: page * 20, limit: 20 }).then((resp) => { setOrders(resp.data.orders); setTotal(resp.data.total); });
  }, [page]);

  return (
    <div>
      <h1 className="font-clash text-2xl font-bold text-white mb-6">Orders</h1>
      <div className="space-y-2">
        {orders.map((o) => (
          <div key={o._id} className="feature-card rounded-lg px-6 py-4 flex flex-wrap items-center justify-between gap-2">
            <div className="min-w-0">
              <p className="text-white text-sm">${(o.amount_paid / 100).toFixed(2)} {o.currency?.toUpperCase()}</p>
              <p className="text-xs text-[#A1A1AA]">{new Date(o.created_at).toLocaleDateString()} &middot; User: {o.user_id?.slice(0, 8)}...</p>
            </div>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-1 min-w-0">
              {o.coupon_code && <span className="text-xs text-[#FF5500]">{o.coupon_code}</span>}
              <code className="text-xs text-[#A1A1AA] font-mono break-all">{o.licence_key}</code>
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between mt-6">
        <span className="text-xs text-[#A1A1AA]">{total} orders total</span>
        <div className="flex gap-2">
          <button disabled={page === 0} onClick={() => setPage(page - 1)} className="text-xs text-[#A1A1AA] hover:text-white disabled:opacity-30">Prev</button>
          <button disabled={(page + 1) * 20 >= total} onClick={() => setPage(page + 1)} className="text-xs text-[#A1A1AA] hover:text-white disabled:opacity-30">Next</button>
        </div>
      </div>
    </div>
  );
}
